import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit
} from '@angular/core';
import {TelegramService} from '../../../../pages/page-telegram/telegram.service';
import {AnimationOptions} from 'ngx-lottie';
import Lottie, {AnimationItem} from 'lottie-web/build/player/lottie_light';
import {AttachmentSticker, IMessengerConnector, Message} from '../../../../types/all.type';

@Component({
  selector: 'app-tgs-player',
  templateUrl: './tgs-player.component.html',
  styleUrls: ['./tgs-player.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TgsPlayerComponent implements OnInit, OnDestroy {
  public visible = false;

  @Input() Service: IMessengerConnector;
  @Input() sticker: AttachmentSticker;
  @Input() message: Message;
  options: AnimationOptions;
  animationItem: AnimationItem;
  lottieStyles: Partial<CSSStyleDeclaration> = {
    maxWidth: '180px',
    margin: '0 auto'
  };
  @HostListener('mouseenter')
  onMouseEnter() {
    this.playSticker();
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    // this.playSticker();
  }

  constructor(
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.cd.detach();
    this.cd.detectChanges();
  }

  getLottie(visible) {
    if (this.Service instanceof TelegramService) {
      this.Service.getFileSrcSticker(this.sticker);
      if (this.sticker.mime_type === 'application/x-tgsticker') {
        this.visible = visible;
        if (!this.sticker.init) {
          this.sticker.init = true;
          Lottie.setSpeed(1);
          Lottie.setQuality('low');
          this.options = {
            renderer: 'svg',
            loop: true,
            autoplay: false,
            rendererSettings: {
              viewBoxOnly: true
            },
            path: this.sticker.file_uri
          };
          this.cd.detectChanges();

        } else {
          if (!visible) {
            this.stopSticker();
          }
        }
      }
    }

    if (this.visible) {
      const index = this.Service.arVisibleStickers.length;
      this.Service.arVisibleStickers.push(this.sticker);
      setTimeout(() => {
        this.playSticker();
      }, 2000 * index);
    } else {
      this.Service.arVisibleStickers = this.Service.arVisibleStickers.filter((v) => v.file_id !== this.sticker.file_id);
      this.stopSticker();
    }
  }

  getFileSrc(sticker) {
    if (sticker.file_uri) {
      return;
    }
    this.Service.getFileSrc(sticker);
    this.cd.detectChanges();
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  onLoopComplete(): void {
    this.stopSticker();
  }

  animationCreated(animationItem: AnimationItem): void {
    this.animationItem = animationItem;
  }

  isFocused() {
    return document.hasFocus();
  }

  stopSticker(): void {
    this.sticker.play = false;
    if (this.animationItem) {
      this.ngZone.runOutsideAngular(() => {
        this.animationItem.stop();
      });
    }
  }

  playSticker(): void {
    if (this.animationItem && this.visible && this.isFocused()) {
      this.ngZone.runOutsideAngular(() => this.animationItem.play());
    }
  }

  loadImageError(event) {
    // this.sticker.file_uri = undefined;
    this.sticker.file_uri_error = true;
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    // this.animationItem.destroy();
  }
}
